import parseUri from 'parse-uri';
import {buildUrl, islocalizationRequired, validateSiteContextBasePath} from './localizeUrlHelper';

// checks if site parameter is already present
function doesSiteParamExist(queryKey) {
    // if there is no service param, fallback to get target param value
    const serviceParam = queryKey.service || queryKey.target;
    // parsing service param
    const serviceParamUri = parseUri(decodeURIComponent(serviceParam));
    const siteParam = serviceParamUri.queryKey && serviceParamUri.queryKey.site;
    if (!siteParam) {
        return false;
    }
    return true;
}

/**
 * This methods prepends basepath to the auth url
 * @param url original url to be localized
 * @param parsedUrl
 * @param siteContext
 * @param options
 * @returns string url with site param appended
 */

const appendSiteParamToUrl = (url, parsedUrl, siteContext, options = {}) => {
    const finalqueryParam = parsedUrl.query + encodeURIComponent(`&site=${siteContext.name}`);
    // building final url
    if (parsedUrl.authority || options.absolute) {
        return buildUrl(url, parsedUrl, siteContext, parsedUrl.path, finalqueryParam);
    }
    return `${parsedUrl.path}?${finalqueryParam}`;
};

/**
 * This function returns localized url This is a special case to localize auth url's where
 * instead of adding basePath we are adding site param in the service param
 */
const localizeAuthUrls = (url, siteContext = {}, options = {}) => {
    if (!islocalizationRequired(url, siteContext)) {
        return url;
    }
    // validate base path and log if missing
    validateSiteContextBasePath(siteContext);

    const parsedUrl = parseUri(url);

    if (doesSiteParamExist(parsedUrl.queryKey)) {
        // dont add site param if it exists already in service param
        return url;
    }
    // appending site param to the url
    return appendSiteParamToUrl(url, parsedUrl, siteContext, options);
};

export {localizeAuthUrls};
